import { Right, Left } from "@insightfulscience/shared-utils/either";
import { mapGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";
import routes from "../routes";

const expectedErrors = mapGqlError({
	INVOICE_QUOTE_FAILED: "errors.INVOICE_QUOTE_FAILED",
});

const onSuccess = routingService => () => routingService.push(routes.quoteSuccess);

export const requestQuote = request => ({ routingService, subscriptionService }) => {
	return subscriptionService
		.requestQuote(request)
		.then(onSuccess(routingService))
		.then(Right)
		.catch(Left.from(expectedErrors));
};
